<script>
export default {
  name: 'BlockListRow',
  components: {},
  props: {},
  data() {
    return {
      
    };
  },
  computed: {
    
  },
  watch: {},
  mounted() {
    
  },
  methods: {
    
  }
}
</script>

<template>
  <div class="block-list-row">
    <div class="block-list-row__left flex align-center justify-start gap">
      <slot name="default"></slot>
    </div>
    <div class="block-list-row__right">
      <slot name="right"></slot>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.block-list-row {
  padding: 12px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;

  & + & {
    position: relative;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 1px;
      background: var(--color-border);
    }
  }
}
</style>